<template>
  <div class="cmlist">
    <code-monkey-list></code-monkey-list>
    <Copyright class="copyright" />
  </div>
</template>

<script>
import Copyright from '@/components/Copyright.vue';
import CodeMonkeyList from '@/components/CodeMonkeyList/Index.vue';

export default {
  name: 'cmlist',

  components: {
    CodeMonkeyList,
    Copyright,
  },
};
</script>

<style lang="less" scoped>
.cmlist {
  position: relative;
}

.copyright {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);

  font-size:12px;
  font-weight:500;
  color:rgba(255,255,255,0.7);
  line-height:17px;
  margin-bottom: 10px;
}</style>
